var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPediaSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search",
    opacity: 0.5,
    clipPath: "url(#clip0_309_7090)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 367"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 25",
    cx: 61.6733,
    cy: 63.5503,
    r: 60.7768,
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 26",
    cx: 61.6732,
    cy: 63.5502,
    r: 47.2709,
    fill: "#E4ECFE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 55",
    d: "M89.9255 104.222H33.5517C32.0852 104.222 30.8965 103.033 30.8965 101.567V25.4286C30.8965 23.9622 32.0852 22.7734 33.5517 22.7734H77.5691L92.5807 36.6303V101.567C92.5807 103.033 91.3919 104.222 89.9255 104.222Z",
    fill: "#F5F8FF",
    stroke: "#B7CEFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 31 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6816 39.7963C37.6816 38.787 38.4999 37.9688 39.5092 37.9688H74.896C75.9054 37.9688 76.7236 38.787 76.7236 39.7963C76.7236 40.8057 75.9054 41.6239 74.896 41.6239H39.5092C38.4999 41.6239 37.6816 40.8057 37.6816 39.7963ZM37.6816 51.0612C37.6816 50.0519 38.4999 49.2336 39.5092 49.2336H85.1696C86.179 49.2336 86.9972 50.0519 86.9972 51.0612C86.9972 52.0706 86.179 52.8888 85.1696 52.8888H39.5092C38.4999 52.8888 37.6816 52.0706 37.6816 51.0612ZM37.6816 62.3261C37.6816 61.3168 38.4999 60.4985 39.5092 60.4985H52.0658C53.0752 60.4985 53.8934 61.3168 53.8934 62.3261C53.8934 63.3355 53.0752 64.1537 52.0658 64.1537H39.5092C38.4999 64.1537 37.6816 63.3355 37.6816 62.3261ZM58.2288 62.3261C58.2288 61.3168 59.047 60.4985 60.0564 60.4985H85.1696C86.179 60.4985 86.9972 61.3168 86.9972 62.3261C86.9972 63.3355 86.179 64.1537 85.1696 64.1537H60.0564C59.047 64.1537 58.2288 63.3355 58.2288 62.3261ZM37.6816 73.591C37.6816 72.5817 38.4999 71.7634 39.5092 71.7634H72.613C73.6223 71.7634 74.4406 72.5817 74.4406 73.591C74.4406 74.6004 73.6223 75.4186 72.613 75.4186H39.5092C38.4999 75.4186 37.6816 74.6004 37.6816 73.591ZM78.776 73.591C78.776 72.5817 79.5942 71.7634 80.6036 71.7634H85.1696C86.179 71.7634 86.9972 72.5817 86.9972 73.591C86.9972 74.6004 86.179 75.4186 85.1696 75.4186H80.6036C79.5942 75.4186 78.776 74.6004 78.776 73.591ZM37.6816 83.7294C37.6816 82.7201 38.4999 81.9018 39.5092 81.9018H81.7451C82.7544 81.9018 83.5727 82.7201 83.5727 83.7294C83.5727 84.7388 82.7544 85.557 81.7451 85.557H39.5092C38.4999 85.557 37.6816 84.7388 37.6816 83.7294ZM37.6816 93.8678C37.6816 92.8585 38.4999 92.0402 39.5092 92.0402H70.33C71.3393 92.0402 72.1576 92.8585 72.1576 93.8678C72.1576 94.8772 71.3393 95.6954 70.33 95.6954H39.5092C38.4999 95.6954 37.6816 94.8772 37.6816 93.8678Z",
    fill: "#B7CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 31 (Stroke)_2",
    d: "M37.6816 39.7963C37.6816 38.787 38.4999 37.9688 39.5092 37.9688H74.896C75.9054 37.9688 76.7236 38.787 76.7236 39.7963C76.7236 40.8057 75.9054 41.6239 74.896 41.6239H39.5092C38.4999 41.6239 37.6816 40.8057 37.6816 39.7963Z",
    fill: "#2D56B2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 56",
    d: "M77.9609 21.7734L93.5816 36.1925H81.9609C79.7518 36.1925 77.9609 34.4016 77.9609 32.1925V21.7734Z",
    fill: "#B7CEFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 373"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22",
    width: 14.7292,
    height: 2.53951,
    rx: 1.26976,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 21.3125 23.7734)",
    fill: "#2D56B2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22_2",
    width: 14.7292,
    height: 2.53951,
    rx: 1.26976,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 10.8965 25.5684)",
    fill: "#2D56B2"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 39",
    cx: 27.2377,
    cy: 59.1146,
    r: 4.3412,
    stroke: "#5388FE",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 40",
    cx: 117.504,
    cy: 72.3812,
    r: 3.60776,
    stroke: "#2D56B2",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 41",
    cx: 11.0066,
    cy: 79.8835,
    r: 1.11008,
    stroke: "#4F86FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.8119 126.732C85.684 126.732 103.415 125.697 103.415 124.42C103.415 123.143 85.684 122.107 63.8119 122.107C41.9398 122.107 24.209 123.143 24.209 124.42C24.209 125.697 41.9398 126.732 63.8119 126.732Z",
    fill: "#B7CEFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 47",
    d: "M84.6356 90.5519L90.5861 84.6014L115.107 105.53C118.11 108.094 118.291 112.673 115.499 115.465C112.707 118.257 108.128 118.076 105.565 115.073L84.6356 90.5519Z",
    fill: "#1A3166"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M88.8613 95.503L105.565 115.074C108.129 118.077 112.708 118.258 115.5 115.466C118.292 112.674 118.111 108.095 115.108 105.532L93.2609 86.8848C92.3818 90.0542 90.8686 92.9721 88.8613 95.503Z",
    fill: "#2D56B2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M77.8414 54.8451L62.4609 90.5533C62.224 90.37 61.9893 90.1803 61.7588 89.9883C60.2723 88.7312 58.9777 87.2541 57.918 85.606L71.2031 54.7622C73.4041 54.3998 75.6498 54.4278 77.8414 54.8451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M88.7746 61.04L74.3137 94.6127C71.31 94.616 68.3458 93.913 65.6504 92.5579L81.4407 55.8965C84.238 57.0149 86.7471 58.7745 88.7746 61.04Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.524 59.7813C62.7238 61.6038 60.5057 64.2406 59.1595 67.3657C57.8131 70.4914 57.4024 73.9588 57.9824 77.3272C58.5623 80.6953 60.105 83.804 62.4063 86.263C64.7069 88.7212 67.6613 90.4193 70.8921 91.1526C74.1224 91.8858 77.493 91.6238 80.5805 90.3977L80.5808 90.3975C82.6318 89.5833 84.5098 88.3624 86.106 86.8014C87.7024 85.2404 88.9856 83.3698 89.8794 81.2948C90.7732 79.2198 91.2593 76.9828 91.3083 74.7121C91.3572 72.4414 90.968 70.1843 90.1641 68.0703L90.164 68.0701C88.9536 64.8861 86.8507 62.1504 84.1305 60.2023C81.4112 58.2548 78.1949 57.1797 74.8884 57.105C71.582 57.0304 68.3234 57.9593 65.524 59.7813ZM53.9849 65.1367C55.7648 61.0048 58.7076 57.4953 62.4505 55.0592C66.1942 52.6225 70.5671 51.3718 75.0156 51.4723C79.464 51.5727 83.7776 53.0194 87.4111 55.6217C91.0438 58.2234 93.8313 61.861 95.4305 66.068C96.4928 68.8617 97.0057 71.84 96.9412 74.8335C96.8767 77.8271 96.2359 80.7799 95.0539 83.5238C93.8719 86.2679 92.1709 88.751 90.0452 90.8297C87.9194 92.9085 85.4105 94.5421 82.6601 95.634C78.5173 97.2793 73.987 97.6326 69.645 96.6471C65.3034 95.6617 61.3541 93.3842 58.2925 90.1129C55.2316 86.8422 53.1946 82.7245 52.4299 78.2832C51.6652 73.8423 52.2053 69.2681 53.9849 65.1367Z",
    fill: "#2D56B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 27",
    d: "M112.908 105.726L95.2412 91.2596C94.6936 90.8112 94.0556 91.4419 94.499 91.9933L108.765 109.737C109.315 110.421 110.11 110.866 110.938 110.953L111.428 111.004C113.119 111.181 114.392 109.844 114.143 108.152L114.085 107.759C113.97 106.983 113.544 106.248 112.908 105.726Z",
    fill: "#9FBDFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22_3",
    width: 22.9185,
    height: 3.95147,
    rx: 1.97574,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 81.1016 64.7734)",
    fill: "#2D56B2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22_4",
    width: 22.9185,
    height: 3.95147,
    rx: 1.97574,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 64.8965 67.5684)",
    fill: "#2D56B2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 366"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22_5",
    width: 12.8004,
    height: 2.20696,
    rx: 1.10348,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 111.947 39.7734)",
    fill: "#5388FE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22_6",
    width: 12.8004,
    height: 2.20696,
    rx: 1.10348,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 102.896 41.334)",
    fill: "#5388FE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 386"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22_7",
    width: 10.8561,
    height: 1.87174,
    rx: 0.935869,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 45.5723 109.773)",
    fill: "#2D56B2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22_8",
    width: 10.8561,
    height: 1.87174,
    rx: 0.935869,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 37.8965 111.098)",
    fill: "#2D56B2"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_7090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0.896484 0.773438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPediaSearch);
export default __webpack_public_path__ + "static/media/PediaSearch.7b73c1ea72019f0462fc9354d790584c.svg";
export { ForwardRef as ReactComponent };